/**
 * @generated SignedSource<<0fe125e44172bdd08f0ad107d3e6f20a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type jobsQueryFragment$data = {
  readonly content: ReadonlyArray<{
    readonly aggregateState: string;
    readonly description: string | null | undefined;
    readonly durable: boolean;
    readonly group: string | null | undefined;
    readonly jobClass: string;
    readonly jobData: any | null | undefined;
    readonly name: string;
    readonly requestsRecovery: boolean;
    readonly triggers: ReadonlyArray<{
      readonly cronExpression: string | null | undefined;
      readonly group: string | null | undefined;
      readonly misfireInstruction: string | null | undefined;
      readonly name: string;
      readonly nextFireTime: any | null | undefined;
      readonly previousFireTime: any | null | undefined;
      readonly priority: number;
      readonly state: string;
      readonly timeZoneId: string | null | undefined;
      readonly type: string;
    }>;
  }>;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"listPaginationQueryFragment">;
  };
  readonly " $fragmentType": "jobsQueryFragment";
};
export type jobsQueryFragment$key = {
  readonly " $data"?: jobsQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"jobsQueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "group",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "jobsQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuartzJobSummary",
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobClass",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requestsRecovery",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobData",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QuartzTriggerSummary",
          "kind": "LinkedField",
          "name": "triggers",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "previousFireTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nextFireTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priority",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "misfireInstruction",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cronExpression",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timeZoneId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aggregateState",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "listPaginationQueryFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuartzJobSummaryPage",
  "abstractKey": null
};
})();

(node as any).hash = "64657c4aa72b61517d56e91570204b3a";

export default node;
